import type { WretchError } from 'wretch';
import { z } from 'zod';

export const responseScheme = z.object({
  Code: z.number(),
  Msg: z
    .string()
    .nullish()
    .transform((v) => v ?? ''),
  LocalizedParams: z.string().nullish(),
});

export const generateResponseScheme = <T extends z.ZodRawShape>(scheme: z.ZodObject<T>) =>
  z.object({
    Code: z.number(),
    Msg: z.string(),
    Data: scheme.nullish(),
  });

export type RespondedWith<T> = {
  Code: number;
  Msg: string;
  Data?: T | null | undefined;
};

export const generateListResponseScheme = (scheme: z.ZodTypeAny) =>
  z.object({
    Code: z.number(),
    Msg: z.string(),
    Data: z.array(scheme).optional(),
  });

export type ListRespondedWith<T> = {
  Code: number;
  Msg: string;
  Data?: T[] | null | undefined;
};

export type RespondedType = z.infer<typeof responseScheme>;

const responseErrorSymbol = Symbol('ResponseError');

export type MaybeResponseError = ResponseError | WretchError;

export class ResponseError extends Error {
  public readonly symbol = responseErrorSymbol;

  constructor(
    public readonly code: number,
    public readonly message: string = '',
  ) {
    super(message ?? '');
  }

  public static isResponseError(error: unknown): error is ResponseError {
    return error instanceof ResponseError;
  }
}
